import { Grid } from '@material-ui/core'

import styled from 'styled-components'

export const Gridinfo = styled(Grid)`
  display: flex;
  flex-direction: column;
`
